var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSun = function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9 2.6V1m0 14.4V17M4.531 4.531 3.4 3.4m10.182 10.182 1.132 1.132M2.6 9H1m14.4 0H17m-3.417-4.469L14.714 3.4M4.532 13.582 3.4 14.714M9 13a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
  })));
};
export { SvgSun as ReactComponent };
export default __webpack_public_path__ + "a80ec03790e483976e2e5971716dae39.svg";